// import { useCallback, useState, useEffect } from 'react'

// import { copyTextToClipboard } from 'utilities/clipboard'

// const useCopyToClipboard = text => {
//   const [copied, setCopied] = useState(false)

//   useEffect(() => {
//     if (copied) {
//       setTimeout(() => {
//         setCopied(false)
//       }, 2000)
//     }
//   }, [copied])

//   const onCopy = useCallback(() => {
//     copyTextToClipboard(text)
//     setCopied(true)
//   }, [text])

//   return [onCopy, copied]
// }

// export default useCopyToClipboard
import { useState } from 'react'

function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState(null)

  const copy = async text => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported')
      return false
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text)
      setCopiedText(text)
      return true
    } catch (error) {
      console.warn('Copy failed', error)
      setCopiedText(null)
      return false
    }
  }

  return [copiedText, copy]
}

export default useCopyToClipboard
